import { render } from "./Funcionalidades.vue?vue&type=template&id=8e759138&scoped=true"
import script from "./Funcionalidades.vue?vue&type=script&lang=js"
export * from "./Funcionalidades.vue?vue&type=script&lang=js"

import "./Funcionalidades.vue?vue&type=style&index=0&id=8e759138&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e759138"]])

export default __exports__